<template>
  <div>
    <v-list class="pa-0">
      <v-list-tile
        v-for="(label, index) in values"
        :key="index"
        class="compact"
      >
        <v-list-tile-content>
          {{ labels[label.name].title }}
        </v-list-tile-content>
        <v-tooltip
          v-if="getTooltip(label)"
          top
        >
          <template v-slot:activator="{ on }">
            <v-list-tile-action
              :data-test="label.name"
              v-on="on"
            >
              <v-menu
                v-if="labels[label.name].variants && !labels[label.name].group"
                :disabled="
                  (labels[label.name].disabledByItemsValid && isDisable) ||
                    (disabled && label.name !== 'description') ||
                    (isDescriptionInSystem && label.name !== 'description') ||
                    labels[label.name].disabled
                "
                menu-props="offsetY"
              >
                <v-chip
                  slot="activator"
                  text-color="white"
                  label
                  small
                  :color="getColor(labels[label.name])"
                >
                  {{
                    labels[label.name].variants.find(
                      v => v.id === labels[label.name].value
                    ).title
                  }}
                </v-chip>

                <v-list class="labels-list-height">
                  <v-list-tile
                    v-for="(variant, index) in labels[
                      label.name
                    ].variants.filter(v => v.id !== labels[label.name].value)"
                    :key="index"
                    @click="labelChanged(variant.id, label)"
                  >
                    <v-tooltip
                      v-if="
                        label.name === 'description' &&
                          ((isDisabledDescriptionInSystem &&
                            variant.id === decriptionVariants.INSYSTEM) ||
                            (isDisabledDescriptionCategories &&
                              variant.id === decriptionVariants.CATEGORIES))
                      "
                      top
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-tile-title
                          class="grey--text default-cursor"
                          v-on="on"
                        >
                          {{ variant.description || variant.title }}
                        </v-list-tile-title>
                      </template>
                      <span v-if="variant.id === decriptionVariants.INSYSTEM">{{
                        labels[label.name].tooltipInSystem
                      }}</span>
                      <span
                        v-else-if="variant.id === decriptionVariants.CATEGORIES"
                      >{{ labels[label.name].tooltipCategories }}</span>
                      <span v-else>{{ labels[label.name].tooltip }}</span>
                    </v-tooltip>
                    <v-list-tile-title v-else>
                      {{ variant.description || variant.title }}
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <combined-label
                v-else
                :label="label"
                :can-edit="labels[label.name].disabled"
                @changeLabel="labelChanged"
              />
            </v-list-tile-action>
          </template>
          <span :data-test="`${label.name}Tooltip`">{{
            labels[label.name].tooltip
          }}</span>
        </v-tooltip>
        <v-list-tile-action v-else>
          <v-menu
            v-if="labels[label.name].variants && !labels[label.name].group"
            :disabled="
              (labels[label.name].disabledByItemsValid && isDisable) ||
                (disabled && label.name !== 'description') ||
                (isDescriptionInSystem && label.name !== 'description') ||
                labels[label.name].disabled
            "
            menu-props="offsetY"
          >
            <v-chip
              slot="activator"
              text-color="white"
              label
              small
              :color="getColor(labels[label.name])"
            >
              {{
                labels[label.name].variants.find(
                  v => v.id === labels[label.name].value
                ).title
              }}
            </v-chip>

            <v-list class="labels-list-height">
              <v-list-tile
                v-for="(variant, index) in labels[label.name].variants.filter(
                  v => v.id !== labels[label.name].value
                )"
                :key="index"
                @click="labelChanged(variant.id, label)"
              >
                <v-tooltip
                  v-if="
                    label.name === 'description' &&
                      ((isDisabledDescriptionInSystem &&
                        variant.id === decriptionVariants.INSYSTEM) ||
                        (isDisabledDescriptionCategories &&
                          variant.id === decriptionVariants.CATEGORIES))
                  "
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-list-tile-title
                      class="grey--text default-cursor"
                      v-on="on"
                    >
                      {{ variant.description || variant.title }}
                    </v-list-tile-title>
                  </template>
                  <span v-if="variant.id === decriptionVariants.INSYSTEM">{{
                    labels[label.name].tooltipInSystem
                  }}</span>
                  <span
                    v-else-if="variant.id === decriptionVariants.CATEGORIES"
                  >{{ labels[label.name].tooltipCategories }}</span>
                  <span v-else>{{ labels[label.name].tooltip }}</span>
                </v-tooltip>
                <v-list-tile-title v-else>
                  {{ variant.description || variant.title }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <combined-label
            v-else
            :label="label"
            :can-edit="labels[label.name].disabled"
            @changeLabel="labelChanged"
          />
        </v-list-tile-action>
      </v-list-tile>
      <v-layout align-center>
        <v-flex>
          <span class="body-1 px-1">Тип упаковки</span>
        </v-flex>
        <v-spacer />
        <v-flex>
          <ColorsLabel :labels="packages" />
        </v-flex>
      </v-layout>
    </v-list>
  </div>
</template>

<script>
import ColorsLabel from "../../../components/label/ColorsLabel.vue";
import combinedLabel from "../../shippings/components/labels/CombinedLabel.vue";
import { labelDescriptionVariants } from "./label-description-variants.js";
import * as goodsDetailsApi from "../../../backend/goodsDetailsApi.js";

export default {
  components: {
    ColorsLabel,
    combinedLabel,
  },
  props: [
    "id",
    "disabled",
    "values",
    "items",
    "isItemsValid",
    "categoriesItems",
    "isDescriptionInSystem",
    "isDisabledDescriptionInSystem",
    "tooltipDescriptionInSystem",
    "packages",
    "isDisabledDescriptionCategories",
    "tooltipDescriptionCategories",
    "shippingAccepted",
    "isDisableDescription",
  ],
  data() {
    return {
      labels: {
        description: {
          title: "Описание",
          value: 0,
          disabledByItemsValid: false,
          disabled: false,
          tooltip:
            "Изменение метки доступно после заполниния поля Менеджер по описанию",
          tooltipInSystem: "",
          tooltipCategories: "",
          variants: [
            { id: 0, title: "Не готово", color: "red" },
            { id: 1, title: "Занесено в систему", color: "green" },
            { id: 2, title: "В работе", color: "grey" },
            { id: 3, title: "Категории", color: "blue darken-1" },
          ],
        },
        fragile: {
          title: "Хрупкий",
          value: 0,
          disabled: false,
          tooltip: "Изменение метки доступно из 'Информация о товаре'",
          variants: [
            { id: 0, title: "Не хрупкий" },
            { id: 1, title: "Хрупкий", color: "red" },
          ],
          type: "boolean",
        },
        mesurable: {
          title: "Обмер груза",
          value: 0,
          disabled: false,
          tooltip:
            "Запрещено менять метку обмер груза. Сформирован приходный ордер",
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Поштучно", color: "green" },
            { id: 2, title: "Общий", color: "green" },
          ],
        },
        definitionCategories: {
          title: "Определение категорий при приеме",
          value: 0,
          disabledByItemsValid: false,
          disabled: true,
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Да", color: "green" },
          ],
          type: "boolean",
        },
        parseByOrders: {
          title: "Разобрать по ордерам",
          value: 0,
          disabled: true,
          tooltip: "Изменить метку можно в Поставке",
          variants: [
            { id: 0, title: "Нет", color: "red" },
            { id: 1, title: "Да", color: "green" },
          ],
          type: "boolean",
        },
        ex: {
          title: "EX",
          disabled: true,
          tooltip: "Изменить метку можно в Поставке",
          group: true,
          name: "ex",
          value: [
            { name: "exWhoDoing", value: 2 },
            { name: "exDocumentInSystem", value: 1 },
          ],
        },
        invoice: {
          title: "Invoice",
          value: 0,
          disabled: true,
          tooltip: "Изменить метку можно в Поставке",
          variants: [
            { id: 0, title: "Нет в системе", color: "red" },
            { id: 1, title: "Есть в системе", color: "green" },
          ],
          type: "boolean",
        },
      },
      definitionCategoriesChanged: false,
    };
  },
  computed: {
    isDisable() {
      return !this.isItemsValid;
    },
    decriptionVariants() {
      return labelDescriptionVariants;
    },
  },
  watch: {
    values: {
      handler() {
        if (!this.values.length) {
          return;
        }
        this.values.forEach(element => {
          element.value
            ? (this.labels[element.name].value = 1)
            : (this.labels[element.name].value = 0);

          if (element.type !== "boolean") {
            this.labels[element.name].value = element.value;
          }
        });
      },
      immediate: true,
    },
    items: {
      handler() {
        if (!this.items.length) {
          return;
        }

        const item = this.items.find(i => i.fragile);
        if (item && this.labels.fragile.value && this.labels.fragile.disabled) {
          return;
        }
        if (
          !item &&
          !this.labels.fragile.value &&
          !this.labels.fragile.disabled
        ) {
          return;
        }
        if (
          !item &&
          this.labels.fragile.value &&
          !this.labels.fragile.disabled
        ) {
          return;
        }
        if (
          item &&
          this.labels.fragile.value &&
          !this.labels.fragile.disabled
        ) {
          this.labels.fragile.disabled = !this.labels.fragile.disabled;
          return;
        }
        const value = this.labels.fragile.value ? 0 : 1;
        const label = this.values.find(v => v.name === "fragile");
        this.labelChanged(value, label);
        this.labels.fragile.disabled = !this.labels.fragile.disabled;
      },
      immediate: true,
    },
    tooltipDescriptionInSystem: {
      handler(value) {
        this.labels.description.tooltipInSystem = value;
      },
      immediate: true,
      deep: true,
    },
    tooltipDescriptionCategories: {
      handler(value) {
        this.labels.description.tooltipCategories = value;
      },
      immediate: true,
      deep: true,
    },
    shippingAccepted: {
      handler(value) {
        this.labels.mesurable.disabled = value;
      },
      immediate: true,
    },
    isDisableDescription: {
      handler(value) {
        this.labels.description.disabled = value;
      },
      immediate: true,
    },
  },
  methods: {
    labelChanged(newValue, label) {
      let value = newValue;
      if (typeof newValue === "number" && label.type === "boolean") {
        newValue === 0 ? (value = false) : (value = true);
      }
      if (
        label.name === "description" &&
        ((newValue === this.decriptionVariants.INSYSTEM &&
          this.isDisabledDescriptionInSystem) ||
          (newValue === this.decriptionVariants.CATEGORIES &&
            this.isDisabledDescriptionCategories))
      ) {
        return;
      }
      this.changeLabelInServer(label, value);
    },
    async changeLabelInServer(label, value) {
      await goodsDetailsApi.changeLabel(this.id, label.name, value);
      if (label.type === "boolean") {
        this.labels[label.name].value = value ? 1 : 0;
      }
      if (label.type != "boolean") {
        this.labels[label.name].value = value;
      }
      this.$emit("change", this.labels);

      this.showInfo("Изменения сохранены");
    },
    getColor(label) {
      return label.disabledByItemsValid && this.isDisable
        ? "grey"
        : label.variants.find(v => v.id === label.value).color
          ? label.variants.find(v => v.id === label.value).color
          : "grey";
    },
    getTooltip(label) {
      if (label.name === "definitionCategories") {
        return false;
      }
      return this.labels[label.name].disabled;
    },
  },
};
</script>

<style>
.compact .v-chip.v-chip--label.v-chip--small {
  height: 19px;
  margin-right: 0px;
}

.compact .v-list__tile {
  padding-left: 4px;
  padding-right: 0px;
}
.v-menu__content .v-list .v-list__tile {
  height: 26px;
  font-size: 14px;
}
</style>
